module.exports = __webpack_public_path__ + "media/icons/facebook-2@2x-ebe00ea5.png";